/* SEVN header icons
   Change the numbers below, hit Save, refresh the page.
   Nothing under the SETTINGS block needs touching. */

/* ================= SETTINGS ================= */

/* Icon sizes in pixels. Bigger number = bigger icon. */
var SEARCH_DESKTOP = 20;
var SEARCH_MOBILE = 18;
var HEART_DESKTOP = 21;
var HEART_MOBILE = 19;
var ACCOUNT_DESKTOP = 19;
var ACCOUNT_MOBILE = 19;
var CART_DESKTOP = 22;
var CART_MOBILE = 22;
var MENU_LINES_SIZE = 27;
var MENU_LINE_THICKNESS = 0.85;

/* Line thickness. Bigger number = thicker lines. */
var LINE_THICKNESS = 1.15;

/* Gap between the menu icon and the search icon on mobile. */
var MENU_SEARCH_GAP = 1.2;

/* true = three lines.  false = the word MENU. */
var MENU_AS_LINES = true;

/* ============ nothing to change below ============ */

var ACCOUNT_LINK = '/pages/account';

(function () {
  function box(sel, px) {
    return sel + ' svg{width:' + px + 'px!important;height:' + px + 'px!important}';
  }
  var css = box('.header__icon--search', SEARCH_DESKTOP)
    + box('.sevn-hi', HEART_DESKTOP)
    + box('.header__icon--account', ACCOUNT_DESKTOP)
    + box('.header__icon--cart', CART_DESKTOP)
    + '.sevn-hi svg{stroke-width:' + LINE_THICKNESS + '!important}'
    + '.sevn-burger{width:' + MENU_LINES_SIZE + 'px;height:' + MENU_LINES_SIZE + 'px;display:block;'
    + 'fill:none;stroke:currentColor;stroke-width:' + MENU_LINE_THICKNESS + ';stroke-linecap:butt;transform:translateX(2px)}'
    + '@media screen and (max-width:749px){'
    + box('.header__icon--search', SEARCH_MOBILE)
    + box('.sevn-hi', HEART_MOBILE)
    + box('.header__icon--account', ACCOUNT_MOBILE)
    + box('.header__icon--cart', CART_MOBILE)
    + '.sevn-left{grid-column:1!important;grid-row:1!important;justify-self:start!important;'
    + 'display:flex!important;align-items:center!important;gap:' + MENU_SEARCH_GAP + 'rem!important}'
    + '.sevn-left header-drawer{margin-left:0!important}'
    + '.sevn-left .header__icon--search{width:auto!important;height:auto!important;padding:0!important;margin:0!important}'
    + '}';
  var s = document.createElement('style');
  s.textContent = css;
  (document.head || document.documentElement).appendChild(s);
})();

(function () {
  var MAG = '<circle cx="11" cy="11" r="6.4"></circle><path d="M15.7 15.7 L19 19"></path>';
  var PERSON = '<circle cx="12" cy="6.9" r="4.6"></circle>'
    + '<path d="M5.2 21.9a6.8 10.4 0 0 1 13.6 0"></path>';
  var BAG = '<path d="M5.4 8.2h13.2l-1 11.4H6.4z"></path>'
    + '<path d="M9.2 10.2V7.6a2.8 2.8 0 0 1 5.6 0v2.6"></path>';
  var BURGER = '<path d="M1.5 5.5H22.5M1.5 12H17.5M1.5 18.5H22.5"></path>';

  function paint(sv, art, mark, cls) {
    if (sv.dataset[mark]) return;
    sv.dataset[mark] = '1';
    sv.setAttribute('viewBox', '0 0 24 24');
    sv.setAttribute('fill', 'none');
    sv.setAttribute('stroke', 'currentColor');
    sv.setAttribute('stroke-width', LINE_THICKNESS);
    sv.setAttribute('stroke-linecap', 'round');
    sv.setAttribute('stroke-linejoin', 'round');
    sv.setAttribute('vector-effect', 'non-scaling-stroke');
    sv.classList.add(cls);
    sv.innerHTML = art;
  }

  function swap() {
    document.querySelectorAll('.header__icon--search, .header__search summary').forEach(function (h) {
      h.querySelectorAll('svg').forEach(function (sv) {
        var cls = sv.getAttribute('class') || '';
        if (cls.indexOf('close') > -1 || cls.indexOf('reset') > -1) return;
        paint(sv, MAG, 'sevnMag', 'sevn-mag');
      });
    });
    document.querySelectorAll('.header__icon--account').forEach(function (h) {
      h.querySelectorAll('svg').forEach(function (sv) { paint(sv, PERSON, 'sevnPerson', 'sevn-person'); });
      if (h.tagName === 'A') h.setAttribute('href', ACCOUNT_LINK);
    });
    document.querySelectorAll('.header__icon--cart').forEach(function (h) {
      h.querySelectorAll('svg').forEach(function (sv) { paint(sv, BAG, 'sevnBag', 'sevn-bag'); });
    });

    if (MENU_AS_LINES) {
      var open = document.querySelector('#Details-menu-drawer-container > summary .open');
      if (open && !open.dataset.sevnBurger) {
        open.dataset.sevnBurger = '1';
        open.innerHTML = '<svg class="sevn-burger" viewBox="0 0 24 24" aria-hidden="true">' + BURGER + '</svg>'
          + '<span class="visually-hidden">Menu</span>';
      }
    }
  }

  if (document.readyState !== 'loading') swap();
  document.addEventListener('DOMContentLoaded', swap);
  window.addEventListener('load', swap);
  document.addEventListener('shopify:section:load', swap);
})();

/* Open the right tab on the account page, including when already on it */
(function () {
  var ALIAS = { wishlist: 'favorites', capsule: 'sizes', 'my-capsule': 'sizes' };

  function openPane(name) {
    name = ALIAS[name] || name;
    var pane = document.querySelector('.sevn-acct__pane[data-pane="' + name + '"]');
    if (!pane) return false;
    document.querySelectorAll('.sevn-acct__nav button').forEach(function (b) {
      b.setAttribute('aria-selected', String(b.dataset.pane === name));
    });
    document.querySelectorAll('.sevn-acct__pane').forEach(function (p) {
      p.classList.toggle('is-on', p.dataset.pane === name);
    });
    return true;
  }

  function fromHash(scroll) {
    var h = (location.hash || '').replace('#', '');
    if (!h) return;
    if (openPane(h) && scroll) window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  window.addEventListener('hashchange', function () { fromHash(true); });
  window.addEventListener('load', function () { fromHash(false); });
  if (document.readyState !== 'loading') fromHash(false);
  document.addEventListener('DOMContentLoaded', function () { fromHash(false); });
})();
